/* TSV Wine Subscription Landing Page JavaScript */
/* Shopify-compatible interactive features */

(function() {
  'use strict';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    initializeWineMap();
    initializeFAQ();
    initializeSmoothScrolling();
    initializeAnimations();
  });

  // Initialize Interactive Wine Region Map
  function initializeWineMap() {
    if (typeof L === 'undefined') {
      console.warn('Leaflet not loaded');
      return;
    }

    // Initialize both desktop and mobile maps
    const desktopMapElement = document.getElementById('wineMap');
    const mobileMapElement = document.getElementById('wineMapMobile');
    
    if (!desktopMapElement && !mobileMapElement) {
      console.warn('No map elements found');
      return;
    }

    try {
      // Initialize desktop map if element exists
      let desktopMap = null;
      if (desktopMapElement) {
        desktopMap = L.map('wineMap').setView([49.2578, 4.0319], 10);
        setupMap(desktopMap);
      }
      
      // Initialize mobile map if element exists
      let mobileMap = null;
      if (mobileMapElement) {
        mobileMap = L.map('wineMapMobile').setView([49.2578, 4.0319], 10);
        setupMap(mobileMap);
      }
      
      // Store map references for potential cleanup
      window.tsvWineMaps = {
        desktop: desktopMap,
        mobile: mobileMap
      };
      
    } catch (error) {
      console.error('Error initializing wine maps:', error);
    }
  }

  // Setup map with tiles and markers
  function setupMap(map) {
    // Add OpenStreetMap tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
      maxZoom: 18
    }).addTo(map);
    
    // Define wine regions with their coordinates and information
    const wineRegions = [
      {
        name: 'Champagne',
        coords: [49.2578, 4.0319],
        description: 'Premium Sparkling Wine & L\'Escapade',
        color: '#7F56D9'
      },
      {
        name: 'Reims',
        coords: [49.2583, 4.0317],
        description: 'Champagne Capital',
        color: '#059669'
      },
      {
        name: 'Épernay',
        coords: [49.0436, 3.9594],
        description: 'Champagne Houses',
        color: '#DC2626'
      },
      {
        name: 'Côte des Blancs',
        coords: [48.9534, 4.0303],
        description: 'Chardonnay Region',
        color: '#EA580C'
      },
      {
        name: 'Montagne de Reims',
        coords: [49.2167, 4.0167],
        description: 'Pinot Noir Dominant',
        color: '#7C3AED'
      }
    ];
    
    // Add markers for each wine region
    wineRegions.forEach(function(region) {
      const marker = L.circleMarker(region.coords, {
        radius: 8,
        fillColor: region.color,
        color: '#fff',
        weight: 2,
        opacity: 1,
        fillOpacity: 0.8
      }).addTo(map);
      
      // Add popup with region information
      marker.bindPopup(
        '<div class="tsv-map-popup">' +
          '<h4 class="tsv-popup-title">' + region.name + '</h4>' +
          '<p class="tsv-popup-description">' + region.description + '</p>' +
        '</div>'
      );
      
      // Add hover effect
      marker.on('mouseover', function() {
        this.setStyle({
          radius: 12,
          fillOpacity: 1
        });
      });
      
      marker.on('mouseout', function() {
        this.setStyle({
          radius: 8,
          fillOpacity: 0.8
        });
      });
    });
    
    // Disable map interactions initially for better UX in overlay
    map.dragging.disable();
    map.touchZoom.disable();
    map.doubleClickZoom.disable();
    map.scrollWheelZoom.disable();
    map.boxZoom.disable();
    map.keyboard.disable();
    
    // Re-enable interactions when user clicks on map
    map.on('click', function() {
      map.dragging.enable();
      map.touchZoom.enable();
      map.doubleClickZoom.enable();
      map.scrollWheelZoom.enable();
      map.boxZoom.enable();
      map.keyboard.enable();
    });
  }

  // Initialize FAQ Accordion
  function initializeFAQ() {
    const faqItems = document.querySelectorAll('.tsv-faq-item');
    
    faqItems.forEach(function(item) {
      const question = item.querySelector('.tsv-faq-question');
      const answer = item.querySelector('.tsv-faq-answer');
      
      if (question && answer) {
        // Initially hide all answers
        answer.style.display = 'none';
        
        question.addEventListener('click', function() {
          const isActive = item.classList.contains('active');
          
          // Close all other FAQ items
          faqItems.forEach(function(otherItem) {
            if (otherItem !== item) {
              otherItem.classList.remove('active');
              const otherAnswer = otherItem.querySelector('.tsv-faq-answer');
              if (otherAnswer) {
                otherAnswer.style.display = 'none';
              }
            }
          });
          
          // Toggle current item
          if (isActive) {
            item.classList.remove('active');
            answer.style.display = 'none';
          } else {
            item.classList.add('active');
            answer.style.display = 'block';
          }
        });
      }
    });
  }

  // Initialize Smooth Scrolling for Navigation Links
  function initializeSmoothScrolling() {
    const navLinks = document.querySelectorAll('a[href^="#"]');
    
    navLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        
        // Skip if it's just "#"
        if (href === '#') return;
        
        const targetElement = document.querySelector(href);
        
        if (targetElement) {
          e.preventDefault();
          
          // Calculate offset for fixed header
          const headerHeight = document.querySelector('.tsv-header').offsetHeight;
          const targetPosition = targetElement.offsetTop - headerHeight - 20;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // Initialize Scroll Animations
  function initializeAnimations() {
    // Intersection Observer for fade-in animations
    if ('IntersectionObserver' in window) {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      };
      
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tsv-animate-in');
          }
        });
      }, observerOptions);
      
      // Observe elements that should animate
      const animateElements = document.querySelectorAll('.tsv-step, .tsv-benefit, .tsv-wine-card, .tsv-review-card, .tsv-pricing-card');
      animateElements.forEach(function(element) {
        element.classList.add('tsv-animate-ready');
        observer.observe(element);
      });
    }
  }

  // Handle CTA Button Clicks
  function handleCTAClicks() {
    const ctaButtons = document.querySelectorAll('.tsv-btn-primary, .tsv-btn-secondary');
    
    ctaButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        const buttonText = this.textContent.trim();
        
        // Track button clicks (you can integrate with analytics here)
        if (typeof gtag !== 'undefined') {
          gtag('event', 'click', {
            event_category: 'CTA',
            event_label: buttonText,
            value: 1
          });
        }
        
        // Handle specific button actions
        if (buttonText.includes('Start Your Journey') || buttonText.includes('Start Explorer') || buttonText.includes('Start Connoisseur') || buttonText.includes('Start Collector')) {
          // Scroll to pricing section or trigger signup flow
          const pricingSection = document.getElementById('pricing');
          if (pricingSection) {
            e.preventDefault();
            const headerHeight = document.querySelector('.tsv-header').offsetHeight;
            const targetPosition = pricingSection.offsetTop - headerHeight - 20;
            
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }
        }
        
        if (buttonText.includes('Gift to a Friend')) {
          // Handle gift flow
          e.preventDefault();
          // You can implement gift functionality here
          console.log('Gift to a friend clicked');
        }
        
        if (buttonText.includes('View All Wines')) {
          // Handle wine catalog navigation
          e.preventDefault();
          // You can implement wine catalog navigation here
          console.log('View all wines clicked');
        }
      });
    });
  }

  // Initialize CTA handling
  document.addEventListener('DOMContentLoaded', handleCTAClicks);

  // Handle Wine Card Interactions
  function initializeWineCards() {
    const wineCards = document.querySelectorAll('.tsv-wine-card');
    
    wineCards.forEach(function(card) {
      card.addEventListener('click', function() {
        const wineName = this.querySelector('.tsv-wine-card-name').textContent;
        
        // Track wine card clicks
        if (typeof gtag !== 'undefined') {
          gtag('event', 'click', {
            event_category: 'Wine Card',
            event_label: wineName,
            value: 1
          });
        }
        
        // You can implement wine detail modal or navigation here
        console.log('Wine card clicked:', wineName);
      });
    });
  }

  // Initialize wine card interactions
  document.addEventListener('DOMContentLoaded', initializeWineCards);

  // Handle Pricing Card Interactions
  function initializePricingCards() {
    const pricingCards = document.querySelectorAll('.tsv-pricing-card');
    
    pricingCards.forEach(function(card) {
      const planName = card.querySelector('.tsv-pricing-title').textContent;
      
      card.addEventListener('click', function(e) {
        // Don't trigger if clicking the button
        if (e.target.classList.contains('tsv-btn-primary')) return;
        
        // Track pricing card clicks
        if (typeof gtag !== 'undefined') {
          gtag('event', 'click', {
            event_category: 'Pricing Card',
            event_label: planName,
            value: 1
          });
        }
        
        // You can implement pricing card interactions here
        console.log('Pricing card clicked:', planName);
      });
    });
  }

  // Initialize pricing card interactions
  document.addEventListener('DOMContentLoaded', initializePricingCards);

  // Handle Form Submissions (if any forms are added)
  function initializeForms() {
    const forms = document.querySelectorAll('form');
    
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        // Handle form submission
        const formData = new FormData(this);
        const formType = this.getAttribute('data-form-type') || 'contact';
        
        // Track form submissions
        if (typeof gtag !== 'undefined') {
          gtag('event', 'submit', {
            event_category: 'Form',
            event_label: formType,
            value: 1
          });
        }
        
        // You can implement form submission logic here
        console.log('Form submitted:', formType, Object.fromEntries(formData));
      });
    });
  }

  // Initialize forms
  document.addEventListener('DOMContentLoaded', initializeForms);

  // Handle Mobile Menu (if needed)
  function initializeMobileMenu() {
    const mobileMenuButton = document.querySelector('.tsv-mobile-menu-button');
    const mobileMenu = document.querySelector('.tsv-mobile-menu');
    
    if (mobileMenuButton && mobileMenu) {
      mobileMenuButton.addEventListener('click', function() {
        mobileMenu.classList.toggle('tsv-mobile-menu-open');
        this.classList.toggle('tsv-mobile-menu-active');
      });
    }
  }

  // Initialize mobile menu
  document.addEventListener('DOMContentLoaded', initializeMobileMenu);

  // Handle Window Resize
  function handleWindowResize() {
    let resizeTimeout;
    
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        // Handle responsive adjustments
        if (window.tsvWineMaps) {
          if (window.tsvWineMaps.desktop) {
            window.tsvWineMaps.desktop.invalidateSize();
          }
          if (window.tsvWineMaps.mobile) {
            window.tsvWineMaps.mobile.invalidateSize();
          }
        }
      }, 250);
    });
  }

  // Initialize window resize handling
  document.addEventListener('DOMContentLoaded', handleWindowResize);

  // Utility Functions
  window.TSVUtils = {
    // Smooth scroll to element
    scrollToElement: function(elementId, offset) {
      const element = document.getElementById(elementId);
      if (element) {
        const headerHeight = document.querySelector('.tsv-header').offsetHeight;
        const targetPosition = element.offsetTop - headerHeight - (offset || 20);
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    },
    
    // Track custom events
    trackEvent: function(category, action, label, value) {
      if (typeof gtag !== 'undefined') {
        gtag('event', action, {
          event_category: category,
          event_label: label,
          value: value
        });
      }
    },
    
    // Show notification (you can implement toast notifications)
    showNotification: function(message, type) {
      // You can implement a toast notification system here
      console.log('Notification:', type, message);
    }
  };

})();
